import { useState, useEffect } from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { IoPersonCircleOutline } from 'react-icons/io5';

import { Box, Avatar, Flex, Image, useToast } from "@chakra-ui/react";
import { manageJoinRoom, resetManageJoinRoom } from '../../digital-sales-room/actions/manage-dsr-member-actions';
import PageLoader from '../../global/components/helper-components/components/PageLoader';
import mapEmptyStateImage from '../dsr-action-list/styles/images/map-empty-state.svg';
import { triggerLaunchdeckToast } from '../../global/helpers/global-helpers';
import { IoIosCheckmarkCircle, IoIosCloseCircleOutline } from 'react-icons/io';

function DsrJoinRequestMgmtModule( {
  dsrId,
  // Action
  manageJoinRoom,
  resetManageJoinRoom,
  // Redux states
  isMobileView,
  joinRoomRequests,
  manageJoinRoomRequestOutcome,
  processingJoinRoomRequest // TODO: Refactor this as there will be a split second lag when redux completes and running logic in FE
}) {
  
  const toast = useToast();
  const [activeJoinRequests, setActiveJoinRequests] = useState("")

  // UX management
  useEffect(() => {
    if (Array.isArray(joinRoomRequests)) {
      setActiveJoinRequests(joinRoomRequests)
    }
  }, [joinRoomRequests]);

  useEffect(() => {
    if (manageJoinRoomRequestOutcome) {
      const { eventProcessed, updateSuccessful } = manageJoinRoomRequestOutcome || {};

      if (updateSuccessful) {
        setActiveJoinRequests(joinRoomRequests) // Still required?
      }

      if (eventProcessed === "approve-join-request" && updateSuccessful) {
        toast(
          triggerLaunchdeckToast({
            useCase: "show-success-state",
            // bannerText: "",
            label: "Succesfully added as a Guest member",
            isMobileView
          })
        )
      }

      resetManageJoinRoom()
    }

  }, [manageJoinRoomRequestOutcome, toast, resetManageJoinRoom, joinRoomRequests]);



  const handleJoinRoomAction = (actionRequired, requestUserIdToken) => {
    let manageJoinRoomPayload = "";

    if (actionRequired === "decline-join-request") {
      manageJoinRoomPayload = {
        event: "decline-join-request",
        dsrId: dsrId,
        // providedRequestUserEmail: requestUserEmail,
        requestUserIdToken
      }
    } else if (actionRequired === "approve-join-request") {
      manageJoinRoomPayload = {
        event: "approve-join-request",
        dsrId: dsrId,
        requestUserIdToken
        // providedRequestUserEmail: requestUserEmail
      }
    }

    manageJoinRoom(manageJoinRoomPayload)
  }

  const renderJoinRequestEmptyState = () => {
      return (
        <Flex justify='center' align='center' py='2.75em' border='1px dotted #E5EAEF' rounded='0.5em' bg='white' w='100%' h='100%'>
  
        <Flex direction='column' justify='center' align='center'>
          {mapEmptyStateImage ? <Image src={mapEmptyStateImage} alt="" /> : <PageLoader />}
  
          <Flex  lineHeight='1.5em'  py='1.5em' fontSize='0.875em' color='gray.500'>
            No outstanding join requests
          </Flex>
  
        </Flex>
  
      </Flex>
      )    
  }

  const renderJoinRequests = () => {
    if (activeJoinRequests) {
      if (activeJoinRequests.length > 0) {
        const displayedJoinRequests = activeJoinRequests?.map((request, requestIndex) => {
          const { requestUserEmail, requestUsername, requestUserIdToken, requestUserProfilePic} = request || {}

          return (

            <Flex key={`join-room-request-${requestIndex}`} className='fade-in' justify='space-between' align='center' w='100%' my='1em' px={['0','1em']}>
              
              <Flex align='center' justify='flex-start'>
                {requestUserProfilePic ?
                    <Avatar h='2.5em' w='2.5em' bg='gray.100' color='gray.700' name={requestUsername} src={requestUserProfilePic} />
                  :
                  // Change this to fallback Avatar image with the same imagery. Currently this is slightly smaller than any Avatar image
                  <Box as={IoPersonCircleOutline} boxSize="2.5em" color="brandDark.500" />
                }
                <Box ml={['0.5em','1em']}>
                  <Flex align='baseline' justify='flex-start'>
                    <Box fontSize={['0.8em','0.875em']} color='brandDark.500'>{requestUsername}</Box>
                  </Flex>
                  <Box fontSize='0.75em' color='gray.500' className="truncate-long-text" maxW={['13em','100%']}>{requestUserEmail}</Box>
                </Box>
              </Flex>

              <Flex justify='flex-end' align='center' gap='0.25em'>                  
                  <Box as={IoIosCloseCircleOutline} boxSize='1.8em' cursor='pointer' color='brandPink.500' onClick={() => handleJoinRoomAction("decline-join-request", requestUserIdToken)}/>
                  <Box as={IoIosCheckmarkCircle} boxSize='1.8em' cursor='pointer' color='brand.500' onClick={() => handleJoinRoomAction("approve-join-request", requestUserIdToken)}/>
              </Flex>

            </Flex>
          )
        })

        return displayedJoinRequests;
      } else {
        return (
        <Flex w='100%' h='100%'>{renderJoinRequestEmptyState()}</Flex>
        )
      }

    } else return (
      <Flex w='100%' h='100%'>{renderJoinRequestEmptyState()}</Flex>
      )
  }


  if (processingJoinRoomRequest === true) {
    return (
      <Flex direction='column' justify='space-around' alignItems='center' py='1em' mt='1em'>
        <PageLoader />
      </Flex>
    )
  } else {
    return (
         <Flex direction='column' justify={['flex-start', 'flex-start', 'center', 'center']} align='center' mt={['1em','2em']} mb='1em' p='1em' border='1px dotted #E5EAEF' rounded='0.5em' bg='gray.50' w='100%' h={['auto', 'auto', '100%', '100%']}>
        <Flex justify={['center','flex-start']} w='100%' fontSize='0.875em' color='brandDark.500' mb={['0em', '1em']} fontWeight='600' px={['1em']}>Requests for approval</Flex>
        {renderJoinRequests()}
      </Flex>
    )
  }

}


const mapStateToProps = (state) => ({
  joinRoomRequests: state.joinRoomRequests.results,
  manageJoinRoomRequestOutcome: state.manageJoinRoomRequestOutcome.results.data,
  processingJoinRoomRequest: state.manageJoinRoomRequestOutcome.isLoading,
  isMobileView: state.mobileViewMode.isMobileView
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      manageJoinRoom,
      resetManageJoinRoom
    },
    dispatch,
  )



export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DsrJoinRequestMgmtModule));
